"use client";

import { BarChart3, ExternalLink } from "lucide-react";
import { useTranslation } from "react-i18next";

export function AddonUpsellCard() {
  const { t } = useTranslation("analytics");
  return (
    <div className="rounded-lg border bg-card p-6">
      <div className="flex items-start gap-4">
        <div className="rounded-full bg-primary/10 p-3 text-primary">
          <BarChart3 className="h-6 w-6" />
        </div>
        <div className="flex-1">
          <h3 className="text-base font-semibold">{t("upsell.title")}</h3>
          <p className="mt-1 text-sm text-muted-foreground">
            {t("upsell.description")}
          </p>
          <a
            href="https://app.zernio.com/settings/billing"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary hover:underline"
          >
            {t("upsell.cta")} <ExternalLink className="h-3.5 w-3.5" />
          </a>
        </div>
      </div>
    </div>
  );
}
